
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface ChartCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

export const ChartCard = ({ title, description, children, className }: ChartCardProps) => {
  return (
    <Card className={cn(
      "bg-card border-border shadow-sm hover:shadow-md transition-all duration-300",
      className
    )}>
      <CardHeader className="border-b border-border bg-card/50">
        <CardTitle className="text-foreground">{title}</CardTitle>
        {description && (
          <CardDescription className="text-muted-foreground">{description}</CardDescription>
        )}
      </CardHeader>
      <CardContent className="p-6 bg-card">
        <div className="recharts-wrapper">
          {children}
        </div>
      </CardContent>
    </Card>
  );
};
